import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AwsService } from '../../providers/appsyncservice/aws.service';
import { UserTypePipePipe } from '../../pipes/user-type-pipe.pipe';
import { positions } from '../../models/positions';
declare var google: any;
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-car-request',
  templateUrl: './car-request.component.html',
  styleUrls: ['./car-request.component.css']
})
export class CarRequestComponent implements OnInit {

  displayValue: Number = 0;
  carRequestlist: any = [];
  carMaster: any = [];
  vehicleDataOne: any = [];  
  modalBoxData: any = [];
  carRequestFm: FormGroup;
  statusFilterFm: FormGroup;
  rowID: any;
  comments: any = [];
  status: any = [
    {id: 2, name: "ACKNOWLEDGED"},
    {id: 3, name: "REJECTED"},
    {id: 4, name: "IN_PROGRESS"},
    {id: 5, name: "COMPLETED"},   
  ];

  constructor(public awserviceProvider: AwsService,
      private formBuilder: FormBuilder) {
      this.getAllData();
   }

  // GET DATA
   getAllData() {
       console.log('Car data getAllData')
       this.awserviceProvider.getCarRequestListAll().then(data => {
        this.carRequestlist = data
        console.log('response', data)
       })
   }
   
   // GET CAR DATA
   getAllCarData() {
    console.log('master car')
    this.awserviceProvider.getCarfilterList().then(data => {
     this.carMaster = data
     console.log('filter--car--response', this.carMaster)
    })
   }
   
   openStatus(carModelBox) {
     console.log('openstatus', carModelBox)
     console.log('this.displayValue', this.displayValue)
     this.modalBoxData = carModelBox.comments
     this.vehicleDataOne = [] 
     if(carModelBox.car_id !== "0") {
      this.awserviceProvider.filterCarRecord(carModelBox.car_id).then(result => {
        console.log('car record', result)
        // this.modalBoxData = carModelBox.comments
        this.vehicleDataOne = result
        console.log('this.vehicleDataOne', this.vehicleDataOne)  
       })
     }  
   }
     
    formInitilization() {
      this.carRequestFm = new FormGroup({
        id: new FormControl(""),
        comments_date: new FormControl(""),
        comments_des: new FormControl(""),
        comments_status: new FormControl(""),
        car_model:  new FormControl("")
      });
    }

    filterfromInit() {
      this.statusFilterFm = new FormGroup({
        filter_status: new FormControl("")
      })
    }

    //  EDIT DATA
    editData(carReq) {
        console.log('editData', carReq)
        this.displayValue = 1;
        this.formInitilization()
        this.getAllCarData()
        this.rowID = carReq.id
        this.comments = carReq.comments
    }

    // Filter for search Status
    onSearchSubmit() {
      console.log('Status Car Filter')

    }
    // SAVE DATA
    onSubmit() {
      console.log('Add - car data', this.carRequestFm.value)
      var test1 = {
        date: this.carRequestFm.value.comments_date,
        des: this.carRequestFm.value.comments_des,
        status: this.carRequestFm.value.comments_status,
        exdata: 0
      }
      var carDataValue = {
        id: this.rowID,
        car_id: (this.carRequestFm.value.comments_status === 'COMPLETED') ?  this.carRequestFm.value.car_model : '0',
        comments:  (this.comments.length === 0) ?  [test1] :  [...this.comments, test1],
        // comments: [...this.comments, test1],
        request_status: this.carRequestFm.value.comments_status,
        car_status: (this.carRequestFm.value.comments_status === 'COMPLETED') ? 'ACTIVE' : '0'
      }
      console.log('this.comments', carDataValue)
      this.awserviceProvider.UpdateCarRequestData(carDataValue).then(result => {
      console.log('-----ts.result-----', result)
       this.MasterCarUpdate(result)   
      }).catch(err => {
      console.log("err",err)
      });
    }

    MasterCarUpdate(result) {
      console.log('MasterCarUpdate', result)
      if(result.car_id !== "0") {
        this.awserviceProvider.UpdateUserIdCarMaster(result).then(result => {
          console.log('UpdateUserIdCarMaster', result)
          this.rowID = ''
          this.comments = ''
          this.getAllData();
          this.displayValue = 0;
        }).catch(err => {
        console.log("err",err)
        });
      } else {
        this.rowID = ''
        this.comments = ''
        this.getAllData();
        this.displayValue = 0;
      }
    }

    backbtn() {
      this.displayValue = 0;
    }

  //   // REFER FROM SC-USER-TRIP - (MASTER)
  //   deleteData(cardata) {        
  //     this.awserviceProvider.deleteCarData(cardata.id).then(res => {
  //       this.getAllData()
  //     }).catch(err => {
  //       console.log(err);
  //     });            
  //   }

   ngOnInit() {
       this.displayValue = 0;
       this.formInitilization()
       console.log('car data module init')
   }

}
